import { ViewportScroller } from '@angular/common';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { ApplicationConfig, inject, provideEnvironmentInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { appRoutes } from './app.routes';
import { LanguageService } from './core/services/language.service';
import { ThemeService } from './core/services/theme.service';

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(
			appRoutes,
			withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
			withRouterConfig({ onSameUrlNavigation: 'reload' }),
		),
		provideHttpClient(withFetch()),
		provideEnvironmentInitializer(() => inject(ViewportScroller).setOffset([0, 64])),
		provideEnvironmentInitializer(() => {
			inject(LanguageService);
			inject(ThemeService);
		}),
	],
};
